import listSaga from './listSaga'
import devicesSaga from './devicesSaga'
import exhibitorDevicesSaga from './exhibitorDevicesSaga'
import exhibitorOrdersSaga from './exhibitorOrdersSaga'
import exhibitorPotentialValuesSaga from './exhibitorPotentialValuesSaga'
import exhibitorQutationRFQStatsSaga from './exhibitorQutationRFQStatsSaga'
import matchListGroupStatsSaga from './matchListGroupStatsSaga'
import matchListStatsSaga from './matchListStatsSaga'
import onboardingStatsSaga from './onboardingStatsSaga'
import ordersSaga from './ordersSaga'
import potentialValuesSaga from './potentialValuesSaga'
import qutationRFQStatsSaga from './qutationRFQStatsSaga'
import visitorPotentialValuesSaga from './visitorPotentialValuesSaga'

const companyStatisticsSagas = [
    listSaga(),
    devicesSaga(),
    exhibitorDevicesSaga(),
    exhibitorOrdersSaga(),
    exhibitorPotentialValuesSaga(),
    exhibitorQutationRFQStatsSaga(),
    matchListGroupStatsSaga(),
    matchListStatsSaga(),
    onboardingStatsSaga(),
    ordersSaga(),
    potentialValuesSaga(),
    qutationRFQStatsSaga(),
    visitorPotentialValuesSaga()
]

export default companyStatisticsSagas
